/* <!--
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
--> */
import {
    Polymer,
    html
} from '@polymer/polymer/polymer-legacy.js';
/*  <!-- Comments and clean up pending in this file --> */

const template = html`
    <style include="app-styles">
        .sessionExpiry {
            position: fixed;
            top: 65px;
            right: 20px;
            z-index: 3;
        }
		:dir(rtl) .sessionExpiry {
            position: fixed;
            top: 65px;
            left: 20px;
			right: auto;
            z-index: 3;
        }
        /* styles for session timeout popup starts here */
         @media (max-width:479px){
            .session-timeout-dialog {
                top: unset !important;
                position: absolute;
                bottom: 0px;                
                margin: 0px;
                display:block !important;
                width: 100%;
                left: 0px;
                right: 0;
                z-index:9999999;
            }           
            .session-expiry-text {
                font-size:16px;
            }
            .flat-button{    
                box-shadow: unset;
            } 
            .st-mobile-background{
                background-color: transparent !important;
                height: 100vh;    
                position: relative;
                z-index: 999999;
            } 
            .closing-button {
                position:relative;
                left:10px;
                top:4px;
            }    
            .close-icon-button {
                color:var(--primary-dark-color);
            }
            .session-timeout-anim {
                animation-duration: 1s;
                animation-fill-mode: both;
            }
            .fadeInBottom { 
                -webkit-animation: fadeInBottom 3s;
                 animation: fadeInBottom 3s;  
            }
            @keyframes fadeInBottom {
                from {
                    opacity: 1;
                    transform: translateY(100%);
                }
                to { 
                    opacity: 1; 
                }
            }   
           .fadeInTop { 
            -webkit-animation: fadeInTop 3s;
             animation: fadeInTop 3s;       
               
            }  
            @keyframes fadeInTop {
                from {
                    bottom:0px;
                }
                to {
                    bottom:-320px;                
                 }
            }      
        }
        /* styles for session timeout popup ends here */
    </style>
    <!-- <template> -->
    <app-media-query desktop="{{desktop}}" tablet="{{tablet}}" phone="{{phone}}"></app-media-query>
        <!-- This screen is displayed after certain idle time-->
        <!--<template  is="dom-if" if="{{showSessionTimeOutNew}}" restamp>
            <div class="session-time-out-desktop" desktop$={{desktop}} tablet$={{tablet}}>
                <template is="dom-if" if="{{!phone}}">
                    <paper-card class="mdl-grid mdl-cell mdl-cell--3-col-phone margin-t-zero margin-r-zero sessionExpiry elevation-4">
                        <div class="mdl-cell--12-col mdl-grid">
                            <div class="mdl-cell font-weight-bold mdl-cell--6-col margin-l-zero primary-dark-text-l">
                                <oe-i18n-msg class=""  msgid="l_SessionTimeout"></oe-i18n-msg>
                            </div>
                        </div>
                        <div  class="mdl-cell margin-t-zero primary-dark-text-m mdl-cell--12-col">
                            <oe-i18n-msg class="" msgid="l_SessionExpireMessage"></oe-i18n-msg>
                            <span class="critical-color-new" id="time">&nbsp;&nbsp;{{countDownTime}}</span>
                        </div>
                        <div  class="mdl-cell primary-dark-text-m mdl-cell--12-col" id="sessiontmmsg">
                            <oe-i18n-msg class="" msgid="">Click continue to stay on the page</oe-i18n-msg>
                        </div>
                        <div class="mdl-cell mdl-cell--12-col"></div>
                        <div  class="mdl-grid mdl-cell mdl-cell--12-col-desktop mdl-grid--no-spacing margin-zero content-align-center">
                            <paper-button id="sessionCont" class="outlineOffset flat-button" on-tap="removeBtn" on-keydown="handleKeydown" on-blur="focusContinue">
                                <oe-i18n-msg msgid="b_Continue"></oe-i18n-msg>
                            </paper-button>
                        </div>
                    </paper-card>
                </template>
            </div>
            <div class="session-time-out-mobile" phone$={{phone}}>
            <template is="dom-if" if="{{phone}}">
                <div class="light-background vertical layout center-center">
                    <div class="text-align-center">	
                        <paper-dialog class="session-timeout-dialog session-timeout-anim fadeInBottom" id="paperdialog">
                            <div class="buttons">                
                                <paper-icon-button class="close-icon-button" icon="close" dialog-confirm icon on-tap="closeSignoutFun"></paper-icon-button>
                            </div>
                            <div class="mdl-grid content-align-center">					
                                <img alt="time out" src="{{imageBaseUrl}}/node_modules/speedboat_ui/images/{{tenantId}}/Session_timeout.svg">
                                <div class="mdl-cell mdl-cell--3-col--phone mdl-cell--12-col-desktop mdl-cell--8-col-tablet text-container">
                                    <p class="session-expiry-text">User session timed out</p>
                                    <p>The current session has timed out.</br> Please login to continue.</p>
                                    <paper-button id="logout_landing_relogin" class="flat-button" raised on-tap="navigatetoLogin">
                                        LOGIN
                                    </paper-button>							
                                </div>												
                            </div>				         
                        </paper-dialog> 
                    </div>
                </div>
            </template>
            </div>
        </template>-->`;

Polymer({
    is: 'session-timeout-prelogin',
    _template: template,
    properties: {
        showSessionTimeOutNew: {
            type: Boolean,
            value: false,
            notify: true,
            observer: 'startTimerMenu'
        },
        countDownTime: {
            type: String,
            notify: true
        },
        sessionIdleTime: {
            type: Number,
            notify: true
        },
        // start of changes made for 257827  issue fix
        loggedin: {
            type: Boolean,
            notify: true
        },
        imageBaseUrl: {
            type: String,
            value: window.OEUtils.uibaseroute
        },
        tenantId: {
            type: String,
            value: sessionStorage.getItem("tenantId")
        },
        selected: {
            type: Number,
            notify: true
        },
        worker1: {
            type: Object,
            notify: true
        }
        // end of changes made for 257827  issue fix
    },
    ready: function () {
        if (config.SpeedBoat.App.sessionTimeOut != undefined) {
            //sessionIdleTime - in miliseconds Ex: 600000 = 10 min
            //idleTimer - accepts 1,2,3. 1 indicated 1 min. 
            this.sessionIdleTime = config.SpeedBoat.App.sessionTimeOut.idleTimer;
        }
    },
    //Calls this function on idle time of configured time. timer values are set here
    startTimerMenu: function () {
        if (this.showSessionTimeOutNew) {
            var timeCount = 60 * this.sessionIdleTime;
            this.startTimer(timeCount);
        }
    },
    //This function is called on sign out button click. Removes listeners navigates to logout
    signoutFun: function () {
        window.removeListners();
        clearTimeout(this.timerVal);
        document.querySelector('session-timeout-prelogin').showSessionTimeOutNew = false;
        if (clientStorage.get(storageType.session, 'shopping-mall')) {
            this.parentNode.querySelector('shopping-mall-landing').handleSessionExpire();
        }
        window.oe_navigate_to("/logout");
        // start of changes made for 257827  issue fix
        if (!this.loggedin) {
            this.selected = 5;
        }
        // end of changes made for 257827  issue fix
    },
    closeSignoutFun: function () {
        var pdialog = "#paperdialog";
        this.$$(pdialog).classList.remove("fadeInBottom");
        this.$$(pdialog).classList.add("fadeInTop");
        setTimeout(function () {
            window.removeListners();
            clearTimeout(this.timerVal);
            document.querySelector('session-timeout-prelogin').showSessionTimeOutNew = false;
            if (clientStorage.get(storageType.session, 'shopping-mall')) {
                this.parentNode.querySelector('shopping-mall-landing').handleSessionExpire();
            }

            window.oe_navigate_to("/logout");

            if (!this.loggedin) {
                this.selected = 5;
            }
        }, 2500);
    },
    //On click of continue this function is called and clears timeout
    removeBtn: function () {
        document.querySelector('session-timeout-prelogin').showSessionTimeOutNew = false;
        document.querySelector("session-timeout-prelogin").countDownTime = "";
        clearTimeout(this.timerVal);
        //  window.worker.terminate();
        this.worker1.terminate();
    },
    //This function calculates count down value for time and logouts automatically on time elapsed
    startTimer: function (duration) {
        var self = this;
        var timer = duration;
        if (typeof this.worker1 != "undefined") {
            this.worker1.terminate();
        }
        var blobURL = URL.createObjectURL(new Blob([`
          var timer = 120,
            minutes,
             seconds;
             var myVar = null;
             myVar = setInterval(function () {
             minutes = parseInt(timer / 60, 10);
             seconds = parseInt(timer % 60, 10);

             minutes = minutes < 10 ? "0" + minutes : minutes;
             seconds = seconds < 10 ? "0" + seconds : seconds;
             countDownTime = minutes + "m " + seconds + "s";
             postMessage( minutes + "m " + seconds + "s");
             --timer;    
             }, 1000);`], {
            type: "application/javascript"
        }));
        this.worker1 = new Worker(blobURL);

        this.worker1.onmessage = function (event) {
            if (--timer >= 0) {
                document.querySelector("session-timeout-prelogin").countDownTime = event.data;
            } else {
                removeListners();
                document.querySelector('session-timeout-prelogin').showSessionTimeOutNew = false;
                self.worker1.terminate();
                if (clientStorage.get(storageType.session, 'shopping-mall')) {
                    self.parentNode.querySelector('shopping-mall-landing').handleSessionExpire();
                }
                addImportLink('./node_modules/speedboat_ui/elements/session-expire-msg.js', true, function () { });
                var role = clientStorage.get(storageType.session, 'role');
                sessionStorage.clear();
                var mainbody = document.getElementById('mainbody');
                mainbody.selected = 14;
                mainbody.loggedin = false;
                mainbody.role = role;
                window.removeListners();
                //window.oe_navigate_to("/logout");
                //start of changes for 257827 issue fix
                if (!self.loggedin) {
                    self.selected = 5;
                }
                //end of changes for 257827 issue fix
            }
        };
    },
    handleKeydown: function (e) {
        if (e.keyCode == 9) {
            setTimeout(function () {
                this.$$("#sessionCont").focus();
            }.bind(this), 0);
        }
        if (e.keyCode === 13) {
            this.removeBtn();
        }
        if (e.shiftKey && e.keyCode == 9) {
            setTimeout(function () {
                this.$$("#sessionCont").focus();
            }.bind(this), 0);
        }
        if (this.showSessionTimeOutNew && e.keyCode == 27) {
            this.removeBtn();
        }
    },
    focusContinue: function () {
        setTimeout(function () {
            this.$$("#sessionSignOut").focus();
        }.bind(this), 0);
    },
    navigatetoLogin: function () {
        //window.oe_navigate_to("/logout", {});
        var mainbody = document.getElementById("mainbody");
        var role = mainbody.role;
        sessionStorage.clear();
        if (window.location.protocol == 'file:') {
            if (getNavigationItem("userAgent").match(/Android|webOS|iPhone|iPod|Blackberry|iPad/i) || role === "consumer" || role === "corporate") {
                this.redirectUrl = localStorage.uibaseroute + "/index.html";
                localStorage.tenantId = "";
            } else if (getNavigationItem("userAgent").match(/Android|webOS|iPhone|iPod|Blackberry|iPad/i) && role === "admin") {
                this.redirectUrl = localStorage.uibaseroute + "/indexAdmin.html";
            }
        } else {
            if (getNavigationItem("userAgent").match(/Android|webOS|iPhone|iPod|Blackberry|iPad/i) || role === "consumer" || role === "corporate") {
                //changes done for multiEntity feature .
                this.redirectUrl = localStorage.uibaseroute + "?bank_id=" + localStorage.getItem("tenantId");
            } else if (getNavigationItem("userAgent").match(/Android|webOS|iPhone|iPod|Blackberry|iPad/i) && role === "admin") {
                this.redirectUrl = localStorage.uibaseroute + "?bank_id=" + localStorage.getItem("tenantId") + "/indexAdmin.html";
            } else if (role === "admin") {
                this.redirectUrl = "?bank_id=" + localStorage.getItem("tenantId") + "/admin";
            } else {
                this.redirectUrl = "?bank_id=" + localStorage.getItem("tenantId");
            }
        }

        location.href = this.redirectUrl;
        if ((typeof (routerPolicy) != "undefined") && routerPolicy.decideNavigation) {
            routerPolicy.decideNavigation({
                url: '/login'
            }, function (e) { }, function (e) { });
        }
    }
});